import {
    Stack,
    Box,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    useMediaQuery,
    Grid,
    IconButton,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EmailIcon from "@mui/icons-material/Email";
import FacebookIcon from "@mui/icons-material/Facebook";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import InstagramIcon from "@mui/icons-material/Instagram";
import useNoWaAdmin from "../../services/queries/useNoWaAdmin";
import { ReactComponent as FAQImage } from "../../assets/images/FAQImage.svg";

interface IFAQProps {}

interface FAQItem {
    id: string;
    question: string;
    answers: React.ReactNode[];
}

const FAQ_ITEMS: FAQItem[] = [
    {
        id: "panel1",
        question: "Apakah keuntungan menggunakan ULO?",
        answers: [
            "1.  Harga yang terjangkau,hanya dengan 600rb perTahun dapat menggunakan POS sistem dengan teknologi sistem terbaru.",
            "2.  Sangat mudah digunakan.",
            "3.  Tidak monoton dan membuat pengguna betah didepan layar.",
        ],
    },
    {
        id: "panel3",
        question:
            "Apakah transaksi dapat menggunakan metode lain seperti transfer bank atau QRIS?",
        answers: [
            "Bisa. Hanya dengan menggunakan nama dan nomor rekening kita dapat mempermudah sistem pembayaran.",
        ],
    },
    {
        id: "panel4",
        question: "Berapa total jenis barang yang dapat diinput dalam ULO?",
        answers: [
            "10 jenis barang untuk pengguna FREE, 500 jenis barang untuk pengguna ULO Standar.",
        ],
    },
    {
        id: "panel6",
        question:
            "Apakah ULO dapat digunakan oleh usaha yang bergerak dibidang jasa?",
        answers: [
            "Sangat bisa! Hanya dengan menonaktifkan jumlah stok barang saja.",
        ],
    },
    {
        id: "panel5",
        question: "Apakah struk transaksi di ULO dapat di cetak?",
        answers: [
            <>
                Bisa, dengan menggunakan <i>thermal printer</i>. Apabila
                pengguna menggunakan perangkat tablet/handphone dapat
                disambungkan melalui Bluetooth, sedangkan jika pengguna
                menggunakan Laptop atau PC dapat menggunakan kabel tambahan.
            </>,
        ],
    },
];

const FAQ = (props: IFAQProps) => {
    const theme = useTheme();
    const isTabletScreen = useMediaQuery(theme.breakpoints.down("md"));
    const isLaptopScreen = useMediaQuery(theme.breakpoints.down("lg"));
    const [expanded, setExpanded] = React.useState<string | false>(
        FAQ_ITEMS[0]?.id ?? "panel1",
    );
    const { data: noWaAdmin } = useNoWaAdmin();

    const handleChange = React.useCallback(
        (panel: string) =>
            (_event: React.SyntheticEvent, isExpanded: boolean) => {
                setExpanded(isExpanded ? panel : false);
            },
        [],
    );

    const contactItems = React.useMemo(
        () => [
            {
                key: "whatsapp",
                icon: <WhatsAppIcon />,
                href: noWaAdmin?.nomor
                    ? `https://wa.me/${noWaAdmin.nomor}`
                    : undefined,
                label: noWaAdmin?.nomor ? `+${noWaAdmin.nomor}` : "-",
            },
            {
                key: "email",
                icon: <EmailIcon />,
                href: "mailto:cs@nore.web.id?subject=Pertanyaan mengenai UKM Lokal",
                label: "cs@nore.web.id",
            },
            {
                key: "facebook",
                icon: <FacebookIcon />,
                href: "https://www.facebook.com/Nore-110554210353267",
                label: "@norewebid",
            },
            {
                key: "instagram",
                icon: <InstagramIcon />,
                href: "https://www.instagram.com/ulo.ukmlokal/",
                label: "@ulo.ukmlokal",
            },
        ],
        [noWaAdmin?.nomor],
    );

    return (
        <Stack
            // paddingY={isTabletScreen ? 2 : 4}
            // paddingX={isTabletScreen ? 2 : 4}
            alignItems="center"
        >
            <Box
                display={isTabletScreen ? "flex" : "grid"}
                gridTemplateColumns={isTabletScreen ? undefined : "1fr 1fr"}
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                padding={3}
                border="1px solid rgba(0, 0, 0, 0.12)"
                borderRadius="6px"
                gap={3}
                // minHeight={"560px"}
                // width={isTabletScreen ? undefined : "fit-content"}
            >
                <Box display="flex" flexDirection="column" alignItems="center">
                    {/* <img
                        src={LoginImage}
                        width={
                            isTabletScreen
                                ? "50%"
                                : isLaptopScreen
                                ? "100%"
                                : 500
                        }
                        height={
                            isTabletScreen
                                ? "50%"
                                : isLaptopScreen
                                ? "100%"
                                : 500
                        }
                        style={{ objectFit: "contain" }}
                        alt="Ilustrasi Main"
                    /> */}
                    <FAQImage
                        width={
                            isTabletScreen
                                ? "70%"
                                : isLaptopScreen
                                  ? "90%"
                                  : 400
                        }
                        style={{ height: "fit-content" }}
                    />
                    {/* <Typography
                        variant="caption"
                        component="div"
                        textAlign="center"
                    >
                        <Link
                            variant="caption"
                            target="_blank"
                            href="https://nore.web.id/"
                            underline="hover"
                        >
                            Nore Inovasi
                        </Link>{" "}
                        {`© ${thisYear}. All right reserved`}
                    </Typography> */}
                </Box>
                <Stack spacing={3}>
                    <Typography
                        variant="h6"
                        fontSize={22}
                        fontWeight={600}
                        textAlign="center"
                    >
                        Pertanyaan Yang Sering Diajukan
                    </Typography>
                    <Box maxWidth="750px">
                        {FAQ_ITEMS.map((item) => (
                            <Accordion
                                key={item.id}
                                expanded={expanded === item.id}
                                onChange={handleChange(item.id)}
                                elevation={0}
                                disableGutters
                                sx={{
                                    border: `1px solid rgba(0,0,0,0.12)`,
                                    "&:not(:last-child)": {
                                        borderBottom: 0,
                                    },
                                    "&:before": {
                                        display: "none",
                                    },
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls={`${item.id}-content`}
                                    id={`${item.id}-header`}
                                >
                                    <Typography
                                        sx={{
                                            width: "80%",
                                            flexShrink: 0,
                                        }}
                                        fontWeight={600}
                                        color="primary"
                                    >
                                        {item.question}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails
                                    sx={{
                                        display: "flex",
                                        borderTop: "1px solid rgba(0,0,0,0.12)",
                                    }}
                                >
                                    <Stack>
                                        {item.answers.map((answer, index) => (
                                            <Typography key={index}>
                                                {answer}
                                            </Typography>
                                        ))}
                                    </Stack>
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </Box>
                    <Stack spacing={2}>
                        <Typography fontWeight={600}>Kontak Kami:</Typography>
                        <Grid container>
                            {contactItems.map((item) => (
                                <Grid item xs={12} md={6} key={item.key}>
                                    <Stack
                                        direction="row"
                                        spacing={1}
                                        alignItems="center"
                                    >
                                        <IconButton
                                            color="primary"
                                            href={item.href ?? "#"}
                                            target={
                                                item.href ? "_blank" : undefined
                                            }
                                            rel={
                                                item.href
                                                    ? "noreferrer"
                                                    : undefined
                                            }
                                        >
                                            {item.icon}
                                        </IconButton>
                                        <Typography>{item.label}</Typography>
                                    </Stack>
                                </Grid>
                            ))}
                        </Grid>
                    </Stack>
                </Stack>
            </Box>
        </Stack>
    );
};

export default FAQ;
